<template>
    <div class="">
        <Header @show-contact="showContact" :active="2" :title="'解决方案'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner_pc" src="../../assets/image/banner/banner_aviation.jpg"></img>
            <img class="banner_m" src="../../assets/image/banner/banner_aviation_m.png"></img>
        </div>
        <!-- 飞行模拟训练 -->
        <p class="titles">飞行模拟训练</p>
        <div class="system-a">
            <div class="contents">
                <img src="../../assets/image/solution/aviation_system.jpg" alt="Image">
                <div class="right">
                    <h1>亮点</h1>
                    <p>
                        第一视角飞行操控<br>
                        逼真视觉效果<br>
                        快速部署、经济高效<br>
                        空间感知能力的提升<br>
                        互动性和协同训练<br>
                        降低成本与训练风险<br>
                    </p>
                </div>
            </div>
            <div class="contents-m">
                <p>亮点:第一视角飞行操控；逼真视觉效果；快速部署、经济高效；空间感知能力的提升；互动性和协同训练；降低成本与训练风险。</p>
                <img src="../../assets/image/solution/aviation_system_m.png" alt="Image">
            </div>
            <div class="mix-a">
                <img src="../../assets/image/solution/aviation_mix1.jpg">
                <img src="../../assets/image/solution/aviation_mix2.jpg">
                <img src="../../assets/image/solution/aviation_mix3.jpg">
                <img src="../../assets/image/solution/aviation_mix4.jpg">
            </div>
        </div>
        
        <p class="titles">飞机科研与教学</p>
        <!-- 飞机科研与教学 -->
        <div class="system-a" style="background-color: #f0fbfe;">
            
            <div class="contents">
                <img src="../../assets/image/solution/aviation_system2.jpg" alt="Image">
                <div class="right">
                    <h1>亮点</h1>
                    <p>
                        <br>优化飞行器设计验证<br>
                        数据驱动飞行器研究<br>
                        沉浸式教学体验<br><br><br>
                    </p>
                </div>
            </div>
            <div class="contents-m">
                <p>
                    亮点：优化飞行器设计验证；数据驱动飞行器研究：沉浸式教学体验。
                </p>
                <img src="../../assets/image/solution/aviation_system2_m.png" alt="Image">
            </div>
            <div class="mix-a">
                <img src="../../assets/image/solution/aviation_mix5.jpg">
                <img src="../../assets/image/solution/aviation_mix6.jpg">
                <img src="../../assets/image/solution/aviation_mix7.jpg">
                <img src="../../assets/image/solution/aviation_mix8.jpg">
            </div>
        </div>
        
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data(){
        return {
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
}
</script>

<style scoped>
@import '../../assets/css/solution/aviation.css';
</style>